import { IBoxWidgetData, IDesktopHeaderSectionData, IElementData, IFooterSectionData, IMeshColumnData, IMeshData, IMeshRowData, IMeshSectionData, IPopUpData, IPopUpSectionData } from "@pageBuilder/typings";
import { ISectionsAreaDataBase } from "src/typings/section-area-data";
import { ObjectUtil } from "src/utils/object-util";

export class CascadeDataCleanUpService {

    public static cleanUp<TData extends IElementData>(data: TData): TData {
        const result = ObjectUtil.deepClone(data);
        switch (result?.type) {
            case "HeaderSectionsArea":
            case "MainSectionsArea":
            case "FooterSectionsArea":
                return this.cleanUpSectionsArea(result) as TData;
            case "MeshSection":
                return this.cleanUpMeshSection(result) as TData;
            case "HeaderDesktopSection":
                return this.cleanUpHeaderDesktopSection(result) as TData;
            case "FooterSection":
                return this.cleanUpFooterSection(result) as TData;
            case "Mesh":
                return this.cleanUpMesh(result) as TData;
            case "MeshRow":
                return this.cleanUpMeshRow(result) as TData;
            case "MeshColumn":
                return this.cleanUpMeshColumn(result) as TData;
            case "BoxWidget":
                return this.cleanUpBoxWidget(result) as TData;
            case "PopUp":
                return this.cleanUpPopUp(result) as TData;
            case "PopUpSection":
                return this.cleanUpPopUpSection(result) as TData;
            default:
                return result;
        }
    }

    private static cleanUpSectionsArea<TData extends ISectionsAreaDataBase>(data: TData): TData {
        data.sections = undefined;
        return data;
    }

    private static cleanUpMeshSection(data: IMeshSectionData): IMeshSectionData {
        data.slides?.filter(slide => slide.content?.mesh)
            .forEach(slide => {
                slide.content.mesh = this.cleanUpMesh(slide.content.mesh);
            });
        return data;
    }

    private static cleanUpHeaderDesktopSection(data: IDesktopHeaderSectionData): IDesktopHeaderSectionData {
        data.content.mesh = this.cleanUpMesh(data.content.mesh);
        return data;
    }

    private static cleanUpFooterSection(data: IFooterSectionData): IFooterSectionData {
        data.content.mesh = this.cleanUpMesh(data.content.mesh);
        return data;
    }

    private static cleanUpPopUpSection(data: IPopUpSectionData): IPopUpSectionData {
        data.content.mesh = this.cleanUpMesh(data.content.mesh);
        return data;
    }

    private static cleanUpPopUp(data: IPopUpData): IPopUpData {
        data.popupSection = undefined;
        return data;
    }

    private static cleanUpMesh(data: IMeshData): IMeshData {
        data.rows = undefined;
        return data;
    }

    private static cleanUpMeshRow(data: IMeshRowData): IMeshRowData {
        data.columns = undefined;
        return data;
    }

    private static cleanUpMeshColumn(data: IMeshColumnData): IMeshColumnData {
        data.widgets = undefined;
        return data;
    }

    private static cleanUpBoxWidget(data: IBoxWidgetData): IBoxWidgetData {
        data.childWidgets = undefined;
        data.hoverChildWidgets = undefined;
        data.isStateDuplicated = false;
        data.hoverStateType = data.hoverStateType === "none" ? "none" : "regular";
        return data;
    }

}
